export const UNKNOWN_ERROR = "Unknown error";
